import { Api } from "./api"

export class FileApi extends Api {
  constructor() {
    super('upload_reports', ['file'])
  }
}
